import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles, articleCategories } from '@/mocks/articles';

const articleImageUrls: Record<string, string> = {
  'a001': 'https://readdy.ai/api/search-image?query=Professional%20outdoor%20winter%20hiking%20scene%20with%20warm%20amber%20lighting%20and%20snowy%20mountain%20landscape%2C%20photographer%20style%2C%20soft%20golden%20hour%20light%20on%20snow-covered%20trail%2C%20modern%20outdoor%20lifestyle%20photography%2C%20warm%20tones%20with%20cold%20environment%20contrast%2C%20high%20detail%20composition&width=800&height=500&seq=art-list-a001&orientation=landscape',
  'a002': 'https://readdy.ai/api/search-image?query=Close-up%20of%20person%20correctly%20applying%20warming%20patch%20on%20clothing%20over%20lower%20back%2C%20lifestyle%20photography%2C%20warm%20cozy%20indoor%20setting%20with%20soft%20natural%20light%2C%20comfortable%20winter%20clothing%20detail%2C%20clean%20modern%20aesthetic%2C%20warm%20amber%20tones&width=800&height=500&seq=art-list-a002&orientation=landscape',
  'a003': 'https://readdy.ai/api/search-image?query=Outdoor%20construction%20worker%20in%20winter%20wearing%20heated%20gear%20with%20warm%20golden%20sunset%20lighting%2C%20professional%20documentary%20style%20photography%2C%20urban%20winter%20setting%20with%20soft%20snow%2C%20warm%20industrial%20aesthetic%2C%20authentic%20working%20scene%20composition&width=800&height=500&seq=art-list-a003&orientation=landscape',
  'a004': 'https://readdy.ai/api/search-image?query=High-tech%20heating%20product%20components%20with%20carbon%20fiber%20and%20modern%20materials%20on%20clean%20warm%20background%2C%20product%20technology%20photography%2C%20soft%20studio%20lighting%20with%20warm%20glow%2C%20innovation%20and%20technology%20aesthetic%2C%20professional%20commercial%20shot&width=800&height=500&seq=art-list-a004&orientation=landscape',
  'a005': 'https://readdy.ai/api/search-image?query=Winter%20travel%20essentials%20neatly%20arranged%20on%20warm%20wooden%20surface%2C%20lifestyle%20flat%20lay%20photography%2C%20soft%20natural%20window%20lighting%2C%20cozy%20winter%20aesthetic%20with%20warm%20amber%20tones%2C%20organized%20travel%20preparation%20scene%2C%20clean%20modern%20composition&width=800&height=500&seq=art-list-a005&orientation=landscape',
  'a006': 'https://readdy.ai/api/search-image?query=Elderly%20person%20comfortably%20reading%20in%20warm%20cozy%20living%20room%20with%20soft%20natural%20light%2C%20lifestyle%20photography%2C%20peaceful%20winter%20indoor%20scene%2C%20warm%20amber%20tones%20and%20comfortable%20atmosphere%2C%20elegant%20senior%20lifestyle%20composition&width=800&height=500&seq=art-list-a006&orientation=landscape',
};

const articlesJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': 'https://rejiujiu.com/articles/#webpage',
      url: 'https://rejiujiu.com/articles',
      name: '热久久暖身指南 - 冬季保暖知识 · 使用技巧 · 出行攻略',
      isPartOf: { '@id': 'https://rejiujiu.com/#website' },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://rejiujiu.com' },
          { '@type': 'ListItem', position: 2, name: '暖身指南', item: 'https://rejiujiu.com/articles' },
        ],
      },
    },
  ],
};

export default function Articles() {
  const [activeCategory, setActiveCategory] = useState('全部');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const filteredArticles = activeCategory === '全部'
    ? articles
    : articles.filter((a) => a.category === activeCategory);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articlesJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <section className="py-10 md:py-14 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-[1280px] mx-auto">
                <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6">
                  <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link>
                  <i className="ri-arrow-right-s-line"></i>
                  <span className="text-foreground-700 font-medium whitespace-nowrap">暖身指南</span>
                </nav>

                <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
                  暖身指南
                </h1>
                <p className="text-sm md:text-base text-foreground-600 mb-8">
                  科学的保暖知识，实用的使用技巧，让温暖更持久
                </p>

                <div className="flex flex-wrap gap-2 mb-10">
                  {articleCategories.map((cat) => (
                    <button
                      key={cat}
                      onClick={() => setActiveCategory(cat)}
                      className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                        activeCategory === cat
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-50 text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70 border border-background-200/70'
                      }`}
                    >
                      {cat}
                    </button>
                  ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                  {filteredArticles.map((article) => {
                    const imgUrl = articleImageUrls[article.id] || '';
                    return (
                      <Link
                        key={article.id}
                        to={`/articles/${article.id}`}
                        className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300"
                      >
                        <div className="aspect-[16/10] overflow-hidden bg-background-100">
                          <img
                            src={imgUrl}
                            alt={article.title}
                            title={article.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          />
                        </div>
                        <div className="p-5">
                          <div className="flex items-center gap-3 mb-2.5">
                            <span className="text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                              {article.category}
                            </span>
                            <span className="text-xs text-foreground-500 whitespace-nowrap">{article.readTime}阅读</span>
                          </div>
                          <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 font-heading">
                            {article.title}
                          </h3>
                          <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                          <div className="mt-3 pt-3 border-t border-background-200/70 flex items-center justify-between">
                            <span className="text-xs text-foreground-500 whitespace-nowrap">{article.date}</span>
                            <span className="text-xs text-primary-600 font-medium flex items-center gap-0.5 whitespace-nowrap">
                              阅读全文
                              <i className="ri-arrow-right-s-line"></i>
                            </span>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}